'use client'

import type { ReactNode } from 'react'

import { hasKitchenDevice } from '@/shared/auth/deviceStorage'
import { hasKitchenSession } from '@/shared/auth/sessionStorage'
import { ClientRedirect } from '@/shared/components/ClientRedirect'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function KitchenGuard({ children }: { children: ReactNode }) {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return <div className="min-h-screen bg-surface" aria-hidden />
  }

  if (!hasKitchenDevice()) {
    return <ClientRedirect href="/kitchen/activate" />
  }
  if (!hasKitchenSession()) {
    return <ClientRedirect href="/kitchen/login" />
  }
  return <>{children}</>
}
